import { account } from "../store/account.module";

export function authHeader() {
  const token = account.state.token;
  const user = account.state.loggeduser;

  if (user) {
    return { Authorization: 'Bearer ' + token}; // for Spring Boot back-end

  } else {
    return {};
  }
}
